import * as React from 'react';

import { BaseComponent } from './BaseComponent';

interface CustomCheckRadioGroupProps extends React.Props<CustomCheckRadioGroup> {
    label: string;
    values: Array<{ label: string, value: string }>;
    defaultValue?: string;
    onChange: (option: string) => void;
    disabled?: boolean;
    type?: 'radio' | 'checkbox';
    value: string | undefined;
}

interface CustomCheckRadioGroupState {
    value: string | undefined;
    checked: boolean;
}

export class CustomCheckRadioGroup extends BaseComponent<CustomCheckRadioGroupProps, CustomCheckRadioGroupState> {
    public componentWillMount(): void {
        this.onChange();
    }

    public render(): React.ReactElement<CustomCheckRadioGroupProps> {
        let tClass: string = 'input-container custom-radio-group custom-checkradio-group';
        if (this.state.checked) {
            tClass += ' custom-checkradio-group--checked';
        }
        return (
            <div className={tClass}>
                <div className="custom-radio-group__label" onClick={this.onClickLabel}>{this.props.label}</div>
                {this.props.values.map((value: { label: string, value: string }, index: number) => {
                    let tOptionClass: string = 'custom-radio-group__option';
                    if (this.props.type === 'checkbox') {
                        tOptionClass += ' custom-radio-group__option--checkbox';
                    }
                    if (!this.props.disabled && this.state.checked && this.state.value === value.value) {
                        tOptionClass += ' custom-radio-group__option--checked';
                    }
                    if (this.props.disabled || !this.state.checked) {
                        tOptionClass += ' custom-radio-group__option--disabled';
                    }
                    return (
                        <div className={tOptionClass} key={index} onClick={this.onClick(value.value)}>
                            <span>{value.label}</span>
                        </div>
                    );
                })}
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            value: this.props.value || this.props.defaultValue,
            checked: this.props.value != null && this.props.value !== '',
        });
    };

    protected onClick = (value: string) => () => {
        if (!this.props.disabled) {
            if (this.props.type === 'checkbox' && this.state.value === value) {
                value = '';
            }
            this.setState({
                value: value
            });
            this.props.onChange(value);
        }
    };

    protected onClickLabel = () => {
        const value: string = this.state.checked ? '' : this.props.defaultValue || '';
        this.props.onChange(value);
        this.setState({
            checked: !this.state.checked,
            value,
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CustomCheckRadioGroup.tsx